import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';
import { ShortcutButtonComponent } from '../shortcut-button/shortcut-button.component';
import { ShortcutList } from '../shortcut-list/shortcut-list.component';
import { ShortcutSystematicListComponent } from '../shortcut-systematic-list/shortcut-systematic-list.component';

@Component({
  imports: [SHARED_MODULES, ShortcutList, ShortcutButtonComponent, ShortcutSystematicListComponent],
  templateUrl: './sidenav-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavPanelComponent {}
